import React, { useEffect, useRef, useState } from 'react';
import { fetchServicePriceAmount, getCachedServicePriceAmount } from '../lib/pricingConfigClient';

export default function ServicePrice({ serviceCode, monthly = false, className = '' }) {
  const [amount, setAmount] = useState(() => getCachedServicePriceAmount(serviceCode));
  const [loading, setLoading] = useState(() => getCachedServicePriceAmount(serviceCode) == null);
  const reqRef = useRef(0);

  useEffect(() => {
    if (!serviceCode) {
      setAmount(null);
      setLoading(false);
      return undefined;
    }

    const cached = getCachedServicePriceAmount(serviceCode);
    if (cached != null) {
      setAmount(cached);
      setLoading(false);
      return undefined;
    }

    let active = true;
    const rid = reqRef.current + 1;
    reqRef.current = rid;
    setLoading(true);

    (async () => {
      const next = await fetchServicePriceAmount(serviceCode);
      if (!active || rid !== reqRef.current) return;
      setAmount(next);
      setLoading(false);
    })();

    return () => {
      active = false;
    };
  }, [serviceCode]);

  if (loading) return <span className={className}>Loading...</span>;
  if (amount == null) return <span className={className}>Price on request</span>;
  const base = `INR ${Number(amount).toLocaleString('en-IN')}`;
  return <span className={className}>{monthly ? `${base} / month onwards` : `${base} onwards`}</span>;
}
